/**
 * A legal signer name may contain letters, spaces, and the punctuation that
 * appears in real names (hyphen, apostrophe, period) — e.g. "Jean-Luc O'Brien Jr."
 * Digits and other symbols are rejected. Must start with a letter.
 */
const SIGNER_NAME_PATTERN = /^\p{L}[\p{L}\s'.-]*$/u;

export function isValidSignerName(name: string): boolean {
  const trimmed = name.trim();
  return trimmed.length > 0 && SIGNER_NAME_PATTERN.test(trimmed);
}
